/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */
export default Number.isInteger || function _isInteger(n) {
  return n << 0 === n;
};


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isInteger.js
// module id = 229
// module chunks = 1